import VideoCard from "@/components/feature/VideoCard";
import SectionHeader from "@/components/feature/SectionHeader";
import type { Video } from "@/types/video";

interface RelatedVideosProps {
  videos: Video[];
}

export default function RelatedVideos({ videos }: RelatedVideosProps) {
  if (videos.length === 0) return null;

  return (
    <section className="mt-14 md:mt-16">
      <SectionHeader title="相关推荐" description="根据类型、题材与热度为你精选的相似作品" />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {videos.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  );
}